(function () {
	'use strict';
	var active = null, trigger = null, previousOverflow = '', requests = Object.create(null), latest = null;
	function open(modal, opener) {
		if (active === modal) { return; }
		var original = trigger;
		if (active) { active.close(); }
		else { previousOverflow = document.documentElement.style.overflow; }
		trigger = opener && !opener.closest('dialog') ? opener : original;
		active = modal;
		document.documentElement.style.overflow = 'hidden';
		modal.showModal();
		document.dispatchEvent(new CustomEvent('folis:modal-open', { detail: { modal: modal, opener: opener || null } }));
	}

	/**
	 * Fetch a product's details dialog once and add it to the page.
	 * Listings render only the button; see folis_render_product_details_button().
	 */
	function loadDetails(link) {
		var id = 'folis-product-details-' + link.dataset.folisProductDetails;
		var existing = document.getElementById(id);
		if (existing) { return Promise.resolve(existing); }
		if (!requests[id]) {
			var url = new URL(link.dataset.folisDetailsUrl, window.location.href);
			if (url.origin !== window.location.origin) { return Promise.reject(new Error('Invalid details URL')); }
			requests[id] = fetch(url.href, { credentials: 'omit', headers: { Accept: 'application/json' } })
				.then(function (response) { if (!response.ok) { throw new Error('Details unavailable'); } return response.json(); })
				.then(function (data) {
					var current = document.getElementById(id);
					if (current) { return current; }
					if (!data || data.id !== id || typeof data.html !== 'string') { throw new Error('Invalid details'); }
					var modal = new DOMParser().parseFromString(data.html, 'text/html').getElementById(id);
					if (!modal || !modal.matches('dialog[data-folis-modal]')) { throw new Error('Invalid details'); }
					document.body.appendChild(document.adoptNode(modal));
					return modal;
				})
				.catch(function (error) { delete requests[id]; throw error; });
		}
		return requests[id];
	}
	function intent(event) {
		var link = event.target.closest && event.target.closest('[data-folis-product-details]');
		if (link) { loadDetails(link).catch(function () {}); }
	}
	document.addEventListener('pointerover', intent, { passive: true });
	document.addEventListener('touchstart', intent, { passive: true });
	document.addEventListener('focusin', intent);

	document.addEventListener('click', function (event) {
		var details = event.target.closest('[data-folis-product-details]');
		if (details) {
			if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
			event.preventDefault();
			latest = details;
			details.setAttribute('aria-busy', 'true');
			loadDetails(details).then(function (modal) {
				details.removeAttribute('aria-busy');
				if (latest === details && document.contains(details)) { open(modal, details); }
			}, function () {
				details.removeAttribute('aria-busy');
				if (latest === details) { window.location.assign(details.href); }
			});
			return;
		}
		var opener = event.target.closest('[data-folis-modal-open]');
		if (opener) {
			latest = null;
			var modal = document.getElementById(opener.dataset.folisModalOpen);
			if (modal && typeof modal.showModal === 'function') { open(modal, opener); }
			return;
		}
		var closer = event.target.closest('[data-folis-modal-close]');
		if (closer) { closer.closest('[data-folis-modal]').close(); return; }
		if (event.target.matches('[data-folis-modal]')) {
			var bounds = event.target.getBoundingClientRect();
			if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) { event.target.close(); }
		}
	});
	document.addEventListener('close', function (event) {
		if (event.target !== active) { return; }
		document.documentElement.style.overflow = previousOverflow;
		if (trigger && document.contains(trigger)) { trigger.focus(); }
		trigger = null; active = null;
	}, true);
}());
